var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#8c99a5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.26,
    height: 13.26,
    viewBox: "0 0 13.26 13.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6,1V3.486H9.116V1H4.144V3.486H1.657V1H0V13.431H13.26V1Zm.829,11.6H.829V5.144h11.6Z",
    transform: "translate(0 -0.171)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3,0h.829V2.486H3Z",
    transform: "translate(-0.514)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,0h.829V2.486H12Z",
    transform: "translate(-2.055)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.05,
    height: 3.05,
    transform: "translate(2.626 6.608)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLight);
export default __webpack_public_path__ + "static/media/calendar-light.d46d7d9d.svg";
export { ForwardRef as ReactComponent };